import React from 'react';
import { NavLink } from 'react-router-dom';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import useAuth from '../../hooks/useAuth';
import { Global } from '../../helpers/Global';
import 'bootstrap/dist/css/bootstrap.min.css';

export const NavigationBar = () => {
  const { auth } = useAuth();
  const rol = auth?.rol;

  // --- Helpers avatar en navbar ---
  const getAvatarUrl = () => {
    if (!auth?.avatar_url) return null;
    // en BD guardamos algo tipo "uploads/avatars/xxx.jpg"
    return `${Global.url}${auth.avatar_url}`;
  };

  const getIniciales = () => {
    const nombre = (auth?.nombre || '').trim();
    const apellidos = (auth?.apellidos || '').trim();
    const n1 = nombre ? nombre.split(' ')[0][0] : '';
    const a1 = apellidos ? apellidos.split(' ')[0][0] : '';
    const combo = (n1 + a1).toUpperCase();
    if (combo) return combo;
    if (nombre) return nombre[0].toUpperCase();
    return '?';
  };

  const avatarUrl = getAvatarUrl();

  return (
    <Navbar expand="lg" className="navi fixed-top">
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="menu">

          <Nav.Link className="item-menu item-nav" as={NavLink} to="inicio">Inicio</Nav.Link>

          {rol === 'admin' && (
            <>
              <NavDropdown className="item-menu nav-dropdown" title="Jornadas" id="jornadas-dropdown">
                <NavDropdown.Item as={NavLink} to="jornada">Nueva</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="misJornadas">Mis Jornadas</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="jornadasAdmin">Listado Completo</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="jornadasCentro">Jornadas por Centro</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="jornadasProcesoAdmin">En proceso</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="crearJornadasAdmin">Inserción manual</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="finalizarJornadasAdmin">Finalización manual</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Intervenciones" id="intervenciones-dropdown">
                <NavDropdown.Item as={NavLink} to="intervencion">Nueva</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="misIntervenciones">Mis Intervenciones</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="intervencionesAdmin">Listado Completo</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="interProcesoAdmin">En proceso</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="crearInterAdmin">Inserción manual</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="finalizarInterAdmin">Finalización manual</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Calendario" id="calendario-dropdown">
                <NavDropdown.Item as={NavLink} to="miCalendario">Mi Calendario</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="calendarioAdmin">Administrar</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="crearPlantillaTurno">Nueva Plantilla</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="plantillaTurnoAdmin">Plantillas</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="global">Global</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Órdenes" id="ordenes-dropdown">
                <NavDropdown.Item as={NavLink} to="crearOrden">Nueva</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="ordenAdmin">Listado Completo</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Clientes" id="clientes-dropdown">
                <NavDropdown.Item as={NavLink} to="crearCliente">Nuevo</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="clientesAdmin">Listado Completo</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Tareas" id="tareas-dropdown">
                <NavDropdown.Item as={NavLink} to="crearTarea">Nueva</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="tableroPersonal">Mis Tareas</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="tableroDepartamento">Tareas Departamento</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="dashboard">Panel Resumen </NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Usuarios" id="usuarios-dropdown">
                <NavDropdown.Item as={NavLink} to="crearUsuario">Nuevo</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="usuariosAdmin">Listado Completo</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="organigrama">Organigrama</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="crearReporteSIL">Reporte SILControl</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="panelControlSIL">Panel SILControl</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="gestionControlSIL">Gestion SILControl</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Departamentos" id="departamentos-dropdown">
                <NavDropdown.Item as={NavLink} to="crearDepartamento">Nuevo</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="departamentosAdmin">Listado Completo</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="organigrama">Organigrama</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Logs" id="logs-dropdown">
                <NavDropdown.Item as={NavLink} to="logs">Logs</NavDropdown.Item>
              </NavDropdown>
            </>
          )}

          {rol === 'gerente' && (
            <>
              <NavDropdown className="item-menu nav-dropdown" title="Jornadas" id="jornadas-dropdown">
                <NavDropdown.Item as={NavLink} to="jornada">Nueva</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="misJornadas">Mis Jornadas</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="jornadasGerente">Listado Completo</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="jornadasCentro">Jornadas por Centro</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="jornadasProcesoGerente">En proceso</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="crearJornadasGerente">Inserción manual</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="finalizarJornadasGerente">Finalización manual</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Intervenciones" id="intervenciones-gerente">
                <NavDropdown.Item as={NavLink} to="intervencion">Nueva</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="misIntervenciones">Mis Intervenciones</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="intervencionesGerente">Listado Completo</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="interProcesoGerente">En Proceso</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="crearInterGerente">Inserción manual</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="finalizarInterGerente">Finalización manual</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Calendario" id="calendario-dropdown">
                <NavDropdown.Item as={NavLink} to="miCalendario">Mi Calendario</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="calendarioAdmin">Administrar</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="crearPlantillaTurno">Nueva Plantilla</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="plantillaTurnoAdmin">Plantillas</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="global">Global</NavDropdown.Item>
              </NavDropdown>
            </>
          )}

          {rol === 'usuario' && (
            <>
              <NavDropdown className="item-menu nav-dropdown" title="Jornadas" id="jornadas-usuario">
                <NavDropdown.Item as={NavLink} to="jornada">Nueva</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="misJornadas">Mis Jornadas</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown className="item-menu nav-dropdown" title="Intervenciones" id="intervenciones-usuario">
                <NavDropdown.Item as={NavLink} to="intervencion">Nueva</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="misIntervenciones">Mis Intervenciones</NavDropdown.Item>
                <NavDropdown.Item as={NavLink} to="listaCentros">Centros</NavDropdown.Item>
              </NavDropdown>
            </>
          )}
        </Nav>

        {/* Usuario alineado a la derecha */}
        <Nav className="ms-auto">
          <NavDropdown
            className="item-menu nav-dropdown nav-user-dropdown"
            id="usuario-dropdown"
            title={
              <span className="nav-user-chip">
                <span className="avatar-navbar">
                  {avatarUrl ? (
                    <img src={avatarUrl} alt={auth?.nombre || 'Usuario'} />
                  ) : (
                    <span className="avatar-fallback-navbar">
                      {getIniciales()}
                    </span>
                  )}
                </span>
                <span className="nav-user-name">
                  {auth?.nombre || 'Usuario'}
                </span>
              </span>
            }
          >
            <NavDropdown.Item as={NavLink} to="misAlertas">Mis Alertas</NavDropdown.Item>
            <NavDropdown.Item as={NavLink} to="cambiarContrasena">Cambio de contraseña</NavDropdown.Item>
            <NavDropdown.Divider />
            <NavDropdown.Item as={NavLink} to="logout">Cerrar Sesión</NavDropdown.Item>
          </NavDropdown>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};
